export default __webpack_public_path__ + "static/media/degot-screenshot-02.2cedec51.png";